import { mount } from "svelte";
import TrainingHub from "../pages/TrainingHub/TrainingHub.svelte";

export const bindTrainingHub = () =>
  mount(TrainingHub, {
    target: document.getElementById("trainingHubContainer"),
    props: {},
  });
